import type { FC } from "react";
import { useMemo } from "react";

import { useExpectedBacklinksParams } from "app/pages/digital-marketing/backlinks/shared/BacklinksUtils";
import { options } from "app/components/React/Table/SWReactTableDefaults";
import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { translate } from "app/filters/i18nFilter";
import { getBacklinksCountriesTableColumns } from "app/pages/digital-marketing/backlinks/reports/overview/components/CountriesWidget/BacklinksCountriesTableColumns";
import { StyledTable } from "app/pages/digital-marketing/backlinks/reports/overview/components/CountriesWidget/BacklinksCountriesTableStyledComponents";

import { useBacklinksSummaryApi } from "../../../../shared/backlinks-api-service";
import { getConvertedTopCountriesData } from "../../BacklinksOverviewDataHelpers";

const tableOptions = options({
    tableType: "swTable--simple",
    showTitle: true,
    showTitleTooltip: true,
    titleType: "text",
    showSubtitle: true,
    showLegend: false,
    preserveLegendSpace: false,
    showSettings: false,
    showTopLine: false,
    showFrame: true,
    titleClass: "page-widget-title",
    emptyResults: false,
});

const tableColumns = getBacklinksCountriesTableColumns();

export const BacklinksCountriesTableWidget: FC = () => {
    const params = useExpectedBacklinksParams();
    const { data, isLoading, isFetching } = useBacklinksSummaryApi({
        key: params.key ?? params.pageFilterParsed?.url,
        status: params.status ?? "All",
    });

    const tableData = useMemo(() => getConvertedTopCountriesData(data?.TopCountries ?? []), [data?.TopCountries]);

    return (
        <WidgetContainer
            title={translate("digitalsuite.backlinks.overview.countries_table.title")}
            isLoading={isLoading || isFetching}
            tooltip={translate("digitalsuite.backlinks.overview.countries_table.tooltip")}
            withBorder={true}
            bodyMinHeight={232}
            automationId="top-countries-chart"
        >
            <StyledTable
                data={tableData}
                columns={tableColumns}
                tableOptions={tableOptions}
                className={"MiniFlexTable"}
            />
        </WidgetContainer>
    );
};
